<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">收费模式</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">执行订单</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">费用和汽油</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">其他费用</a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">费用相关常见问题解答</a></p>
          <!-- <div class="subAnchor">
            <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
            <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
            <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
            <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
            <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
            <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
            <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
          </div> -->
        </div>
      </div>
      <div id="box1" class="p1">收费模式</div>
      <div class="p3">本章详细内容如下：</div>
      <div class="p3">
        <ul style="padding-left:30px;word-break:break-all">
          <li>每个交易者都可以获得最新交易价格的数据。新上市的货币对将初始价格作为最新交易价格。</li>
        </ul>
      </div>
      <div id="box2" class="p2">执行订单</div>
      <div class="p4">收费条件</div>
      <div class="p3">订单执行时，按成交金额的比例收取一定的费用。</div>
      <div class="p4">费用优先</div>
      <div class="p3">使用用户最终获得的代币支付手续费。</div>
      <div class="p4">收费规则</div>
      <div class="p3">
        <ol style="padding-left:30px;word-break:break-all">
          <li>先执行命令。移除已售出的代币，并在用户账户中添加已购买的代币</li>
          <li>费用 = 购买的加密货币 * feeRate</li>
        </ol>
      </div>
      <div id="box3" class="p2">费用和汽油</div>
      <div class="p3">每笔交易可能会提供费用或汽油价格，但不能同时提供。</div>
      <div class="p3">验证者有一个最低 gas 价格（多币种）配置，他们在确定是否应该在 CheckTx 期间将交易包含在一个块中时使用此值，其中gasPrices >= minGasPrices。请注意，您的交易必须提供大于或等于验证者要求的任何面额的费用。</div>
      <div class="p3">注意：有了这样的机制，验证者可能会开始在内存池中按gasPrice对 txs 进行优先级排序，因此提供更高的费用或 gas 价格可能会产生更高的 tx 优先级。</div>
      <div class="p3">例如</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli tx send ... --fees=0.0002fax</div>
        </div>
      </div>
      <div class="p3">或者</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli tx send ... --gas-prices=0.000000001fax</div>
        </div>
      </div>
      <div class="p3">您需要使用该--gas标志来指定您要为此交易提供的气体数量，使用 或。当用于自动估算所需气体时，还提供一个很好的建议，其中比率应为 1.5 或 2.0。--gas number--gas auto--gas auto--gas-adjustment ratio</div>
      <div class="p3">您需要使用–gas标志来指定要为此交易提供的 gas 数量，可以使用–gas number 或–gas auto。当使用–gas auto 来自动估计所需的气体时，一个好的建议是提供–gas-adjustment ratio，其中 ratio 应该是 1.5 或 2.0。</div>
      <div id="box4" class="p2">其他费用</div>
      <div class="p3">除上述费用外，FaxChain 还将针对以下订单收取一些额外费用作为业务费。</div>
      <div id="box5" class="p2">费用相关常见问题解答</div>
      <div class="p3">1. 扣费规则 * 如果提供-fees numFees，无论成功或失败，链都会从运营账户中扣除“numFees”。* 如果提供–gas - prices ，无论成功与否，链都会从运营账户中扣除gas_wanted*gas-prices 。* 目前 FaxChain 不会返还提供的超额气体，即。如果提供的gas（gas_wanted）小于gas used（gas_used），则链将消耗gas_wanted gas并失败；如果 gas_wanted 大于 gas_used，chain 也会消耗 gas_wanted。</div>
      <div class="p3">2.为什么提供“-fees intFees”时账户余额不是整数</div>
      <div class="p3">
        <ul style="padding-left:30px;word-break:break-all">
          <li>宇宙交易</li>
          <li>以太坊交易</li>
        </ul>
      </div>
      <div class="p3">除了 Gas 费，Chain 还会消耗一些额外的 Dex 和 Token 交易费用。</div>

      
    </div>
    
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">收费模式</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">执行订单</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">费用和汽油</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">其他费用</a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">费用相关常见问题解答</a></p>
      <!-- <div class="subAnchor">
        <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
        <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
        <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
        <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
        <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
        <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
        <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'feeModel',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>